var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0547 2H7.05469C4.29326 2 2.05469 4.23858 2.05469 7V17C2.05469 19.7614 4.29326 22 7.05469 22H17.0547C19.8161 22 22.0547 19.7614 22.0547 17V7C22.0547 4.23858 19.8161 2 17.0547 2Z",
    stroke: "#A7A7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0544 11.3698C16.1778 12.2021 16.0357 13.052 15.6482 13.7988C15.2607 14.5456 14.6475 15.1512 13.896 15.5295C13.1445 15.9077 12.2928 16.0394 11.4622 15.9057C10.6315 15.7721 9.86416 15.3799 9.26923 14.785C8.67431 14.1901 8.28213 13.4227 8.14846 12.592C8.0148 11.7614 8.14646 10.9097 8.52472 10.1582C8.90298 9.40667 9.50858 8.79355 10.2554 8.40605C11.0022 8.01856 11.8521 7.8764 12.6844 7.99981C13.5333 8.1257 14.3192 8.52128 14.9261 9.12812C15.5329 9.73496 15.9285 10.5209 16.0544 11.3698Z",
    stroke: "#A7A7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5547 6.5H17.5647",
    stroke: "#A7A7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/InstaIcon.530c93ba9ca6c278474fd57429175e7b.svg";
export { ForwardRef as ReactComponent };